export const SSPLITTER_UNITS = ['%', 'px'] as const;
/** 모델·limits 를 읽는 단위. Quasar QSplitter 의 `unit` 과 같다. */
export type SSplitterUnit = (typeof SSPLITTER_UNITS)[number];

/** limits 를 주지 않았을 때의 기본 범위. Quasar 와 같은 값이다. */
export const SSPLITTER_DEFAULT_LIMITS: Record<SSplitterUnit, readonly [number, number]> = {
  '%': [10, 90],
  'px': [50, Infinity],
};

/** value·defaultValue 를 주지 않았을 때의 시작값. */
export const SSPLITTER_DEFAULT_VALUE: Record<SSplitterUnit, number> = {
  '%': 50,
  'px': 240,
};

/**
 * 방향키 한 번에 움직이는 양. 단위가 다르면 체감도 달라야 하므로 단위별로 둔다.
 * 두께·색과 달리 대응 토큰이 없어 상수다(SLAYOUT_MIN_WIDTH 와 같은 이유).
 */
export const SSPLITTER_KEY_STEP: Record<SSplitterUnit, { normal: number; large: number }> = {
  '%': { normal: 1, large: 10 },
  'px': { normal: 10, large: 50 },
};
